import { useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Box,
  Dialog,
  DialogTitle,
  InputAdornment,
  Portal,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";

import { sendTilausvahvistus_exported } from "src/data/keikka/handleKeikka";
import mailClass from "src/data/system/mailClass";
import { getReplyToEmail as getReplyAddressForEmail } from "../SendTilaustiedotButton/HandleSendTilaustiedotModal";
import { useUserData } from "src/context/userContext";

import MyDivider from "../../layout/MyDivider";
import StepButtons from "../../buttons/StepButtons/StepButtons";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import { EmailAtIcon, EmailIcon } from "src/components/icons/MediaIcons";

export default function SendTilausVahvistusModal(props) {
  const keikkaData = props.keikkaData;
  const emailToRef = useRef(null);
  const replyToRef = useRef(null);
  const { user, token, socket } = useUserData();
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarIsOpen(false);
  };
  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setSnackbarIsOpen(true);
  };
  const replyAddress = getReplyAddressForEmail(keikkaData);

  const handleCancelKlik = async () => props.close();

  const handleAcceptKlik = async () => {
    const personId = user.personId;

    const thisMail = new mailClass(keikkaData);
    thisMail.emailToEmail = emailToRef.current.value;
    thisMail.replyToEmail = replyToRef.current.value;
    sendTilausvahvistus_exported(thisMail, keikkaData, personId, token, socket).then(() => {
      handleSnackbarOpen("Tilausvahvistus lähetetty");
    });
    props.close();
  };
  return (
    <>
      <Portal>
        <Snackbar
          open={snackbarIsOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <Alert onClose={handleSnackbarClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 1 },
            paddingLeft: "20px",
            paddingRight: "20px",
            width: "100%",
          }}
          noValidate>
          <Typography color="primary" variant="body">
            Tämä lähettää tilausvahvistuksen asiakkaan sähköpostiin.
          </Typography>
          <MyDivider />
          <div className="spaceBetween">
            <Typography color="primary" variant="body2">
              Lähettäjä: noreply@betoni.online
            </Typography>
            <HelperIcon helpId="sendTilausvahvistus" alignRight={false} />
          </div>
          <TextField
            label="reply to (email)"
            defaultValue={replyAddress}
            fullWidth
            variant="standard"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailAtIcon />
                  </InputAdornment>
                ),
              },
            }}
            inputRef={replyToRef}
          />
          <TextField
            label="Vastaanottaja (email)"
            defaultValue={props.keikkaData.keikkaContactPerson.personEmail}
            fullWidth
            variant="standard"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailAtIcon />
                  </InputAdornment>
                ),
              },
            }}
            inputRef={emailToRef}
          />
          <StepButtons
            enableButtonAfterKlik
            onCancelKlik={() => handleCancelKlik()}
            onAcceptKlik={() => handleAcceptKlik()}
            rightButtonDisabled={false}
            rightButtonText="LÄHETÄ SÄHKÖPOSTI"
          />
        </Box>
      </Dialog>
    </>
  );
}

SendTilausVahvistusModal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  keikkaData: PropTypes.object,
};
